import React from 'react';

const Skills = () => {
  const skillsData = {
    ciCdAutomation: [
      { icon: 'fab fa-jenkins', name: 'Jenkins', description: 'CI/CD Pipeline automation', percentage: 85 },
      { icon: 'fab fa-github', name: 'GitHub Actions', description: 'Workflow automation', percentage: 80 },
      { icon: 'fab fa-git-alt', name: 'Git', description: 'Version control (Branching, PRs)', percentage: 90 },
      { icon: 'fab fa-github', name: 'GitHub', description: 'Collaborative development', percentage: 88 }
    ],
    cloudContainers: [
      { icon: 'fab fa-docker', name: 'Docker', description: 'Containerization', percentage: 88 },
      { icon: 'fas fa-dharmachakra', name: 'Kubernetes', description: 'Orchestration & Deployment', percentage: 75 },
      { icon: 'fab fa-aws', name: 'AWS Cloud', description: 'EC2, S3, IAM services', percentage: 80 },
      { icon: 'fas fa-server', name: 'Terraform', description: 'Infrastructure as Code (IaC)', percentage: 70 }
    ],
    infrastructureScripting: [
      { icon: 'fab fa-linux', name: 'Linux (Ubuntu)', description: 'System Administration', percentage: 92 },
      { icon: 'fas fa-terminal', name: 'Bash Scripting', description: 'Automation & Scripting', percentage: 85 }
    ]
  };

  return (
    <section id="skills" className="skills-section">
      <div className="container">
        <h2 className="section-title">My Skills</h2>

        {/* CI/CD & Automation */}
        <div className="skill-category-section">
          <div className="category-header">
            <i className="fas fa-sync-alt category-icon"></i>
            <h3>CI/CD & Automation</h3>
          </div>
          <div className="skills-grid">
            {skillsData.ciCdAutomation.map((skill, index) => (
              <div key={index} className="skill-card">
                <div className="skill-logo-wrapper">
                  <i className={skill.icon}></i>
                </div>
                <h4 className="skill-name">{skill.name}</h4>
                <p className="skill-description">{skill.description}</p>
                <div className="skill-level">
                  <span className="skill-percentage">{skill.percentage}%</span>
                  <div className="skill-bar">
                    <div className="skill-progress" style={{ width: skill.percentage + '%' }}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Cloud & Containers */}
        <div className="skill-category-section">
          <div className="category-header">
            <i className="fas fa-cloud category-icon"></i>
            <h3>Cloud & Containers</h3>
          </div>
          <div className="skills-grid">
            {skillsData.cloudContainers.map((skill, index) => (
              <div key={index} className="skill-card">
                <div className="skill-logo-wrapper">
                  <i className={skill.icon}></i>
                </div>
                <h4 className="skill-name">{skill.name}</h4>
                <p className="skill-description">{skill.description}</p>
                <div className="skill-level">
                  <span className="skill-percentage">{skill.percentage}%</span>
                  <div className="skill-bar">
                    <div className="skill-progress" style={{ width: skill.percentage + '%' }}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Infrastructure & Scripting */}
        <div className="skill-category-section">
          <div className="category-header">
            <i className="fas fa-tools category-icon"></i>
            <h3>Infrastructure & Scripting</h3>
          </div>
          <div className="skills-grid">
            {skillsData.infrastructureScripting.map((skill, index) => (
              <div key={index} className="skill-card">
                <div className="skill-logo-wrapper">
                  <i className={skill.icon}></i>
                </div>
                <h4 className="skill-name">{skill.name}</h4>
                <p className="skill-description">{skill.description}</p>
                <div className="skill-level">
                  <span className="skill-percentage">{skill.percentage}%</span>
                  <div className="skill-bar">
                    <div className="skill-progress" style={{ width: skill.percentage + '%' }}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;